import React from 'react'

import { BodyText, HeadingXSmall } from '@pb/components'

import OPTIMIZELY from 'constants/optimizely'
import useAccountFeature from 'features/account/hooks/useAccountFeature'
import useOptimizelyToggle from 'features/account/hooks/useOptimizelyToggle'
import RecentlyViewed from 'features/account/recently-viewed/index'
import { UserMenu } from 'features/account/user-menu'

import styles from '../Hub.scss'
import PendingMemberNotice from '../PendingMemberNotice'

export interface PrimitiveProps {
  userDisplayName?: string
  userEmail?: string
}

export interface EventProps {
  pendingMemberTryAgainAction: () => void
}

export type MobilePendingMemberProps = PrimitiveProps & EventProps

const MobilePendingMember: React.FC<MobilePendingMemberProps> = ({
  userDisplayName,
  userEmail,
  pendingMemberTryAgainAction,
}) => {
  const {
    pages: {
      hub: { shouldShowClubCard, shouldShowPendingMemberNotice },
    },
  } = useAccountFeature()
  /**
   * Only for A/B testing purposes
   * TODO: remove when iterative testing of component is completed.
   * https://hmgroup.atlassian.net/browse/CRMMA-5370
   */
  const isRecentlyViewedEnabled = useOptimizelyToggle({
    key: OPTIMIZELY.ACCOUNT_RECENTLY_VIEWED,
  })
  return (
    <main id="main-content">
      {shouldShowClubCard && (
        <div className={styles.userInfo}>
          {userDisplayName && <HeadingXSmall Tag="p">{userDisplayName}</HeadingXSmall>}
          <BodyText>{userEmail}</BodyText>
        </div>
      )}
      {shouldShowPendingMemberNotice && (
        <PendingMemberNotice action={pendingMemberTryAgainAction} />
      )}
      <UserMenu />
      {isRecentlyViewedEnabled && <RecentlyViewed />}
    </main>
  )
}

export default MobilePendingMember
